import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    this.sync();
  }

  sync() {
    const chosen = this.element.querySelector('input[type=radio]:checked') !== null;

    for (const field of this.element.elements) {
      if (field.type === 'submit') {
        field.disabled = !chosen;
      }
    }
  }
}
